import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BaggageLDisabledFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M23.1299 2.81L22.0999 1.78L18.7299 5.15C18.7299 5.15 18.7199 5.15 18.7099 5.14L12.7999 11.05V11.08L11.1899 12.69V12.66L9.3199 14.53V14.56L7.7099 16.17V16.14L4.4999 19.35C4.4999 19.36 4.4999 19.37 4.4999 19.38L2.1499 21.73L3.1799 22.76L5.1199 20.82C5.5099 21.2 6.0499 21.44 6.6399 21.44C6.6399 22.02 7.1199 22.49 7.7099 22.49C8.2999 22.49 8.7799 22.02 8.7799 21.44H15.2099C15.2099 22.02 15.6899 22.49 16.2799 22.49C16.8699 22.49 17.3499 22.02 17.3499 21.44C18.5299 21.44 19.4899 20.49 19.4899 19.34V6.74C19.4899 6.65 19.4899 6.55 19.4699 6.46L23.1299 2.8V2.81ZM9.3199 17.51C9.3199 17.94 8.9599 18.3 8.5199 18.3C8.0799 18.3 8.0699 18.2 7.9199 18.03L9.3199 16.63V17.51ZM12.7999 17.51C12.7999 17.94 12.4399 18.3 11.9999 18.3C11.5599 18.3 11.1999 17.94 11.1999 17.51V14.75L12.8099 13.14V17.51H12.7999ZM16.2899 17.51C16.2899 17.94 15.9299 18.3 15.4899 18.3C15.0499 18.3 14.6899 17.94 14.6899 17.51V11.27L16.2999 9.66V17.51H16.2899ZM7.7099 14.07V9.64C7.7099 9.21 8.0699 8.85 8.5099 8.85C8.9499 8.85 9.3099 9.21 9.3099 9.64V12.47L11.1799 10.6V9.65C11.1799 9.22 11.5399 8.86 11.9799 8.86C12.4199 8.86 12.4599 8.98 12.6099 9.16L17.1099 4.66H15.1899V2.56C15.1899 1.98 14.7099 1.51 14.1199 1.51H9.8299C9.2399 1.51 8.7599 1.98 8.7599 2.56V4.66H6.6199C5.4399 4.66 4.4799 5.61 4.4799 6.76V17.3L7.6899 14.09L7.7099 14.07ZM10.3899 3.08H13.5999V4.66H10.3899V3.08Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BaggageLDisabledFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BaggageLDisabledFilledIcon;
